import { gql } from '@apollo/client';

export const GetFindGroupFindsQueryName = 'GetFindGroupFinds';

export const GET_FIND_GROUP_FINDS_QUERY = gql`
  query ${GetFindGroupFindsQueryName}($groupId: String!, $filters: Filters) {
    getFindGroupFinds(groupId: $groupId, filters: $filters) {
      id
      evId
      createdAt
      description
      updatedAt
      foundAt
      material
      era
      type
      note
      siteId
      groupIds
      latitude
      longitude
      shared
      visibility
      image
      images
      amcrId
      amcrData {
        images
      }
    }
  }
`;
